<template>
	<div class="PublishPackage">
		<!-- <header>
            <div class="header">
                <div class="item"><i class="el-icon-plus" :size="16"></i><p>新增</p></div>
                <div class="item"><i class="el-icon-edit-outline"></i><p>修改</p></div>
                <div class="item"><i class="el-icon-close"></i><p>彻底删除</p></div>
                <div class="item"><i class="el-icon-s-claim"></i><p>保存</p></div>
                <div class="item"><i class="el-icon-d-arrow-left"></i><p>首页</p></div>
                <div class="item"><i class="el-icon-arrow-left"></i><p>上一页</p></div>
                <div class="item"><i class="el-icon-arrow-right"></i><p>下一页</p></div>
                <div class="item"><i class="el-icon-d-arrow-right"></i><p>末页</p></div>
            </div>
        </header> -->
		<main>
			<div>
				<el-button @click="btnadd()" class="btnlist" type="primary">新增</el-button>
			</div>
			<div class="tabs">
				<div :class="activeName == 'first' ? 'on item' : 'item'">数据浏览</div>
				<div :class="activeName == 'detail' ? 'on item' : 'item'">详细信息</div>
				<div style="margin-left: auto; margin-top: 5px; margin-bottom: 5px">
					<el-input @change="queryList()" placeholder="查询" v-model="formInline.keyword">
						<i style="color: rgba(61, 127, 255, 1)" slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</div>
			</div>
			<!-- 列表 -->
			<div class="gamelist" v-if="activeName == 'first'" v-loading.fullscreen.lock="loading">
				<el-table :data="tableData" style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
					<el-table-column label="序号" width="60px" align="left">
						<template slot-scope="scope">
							{{ (formInline.pageIndex - 1) * 10 + scope.$index + 1 }}
						</template>
					</el-table-column>

					<el-table-column prop="publishSubject" label="发布主题"></el-table-column>
					<el-table-column label="发布类型">
						<template slot-scope="scope">
							<span>
								{{ scope.row.publishType == 0 ? '团体' : '个体' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="发布类型">
						<template slot-scope="scope">
							<span>
								{{ scope.row.trainType == 0 ? '发布训练' : '发布套餐' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="开始时间">
						<template slot-scope="scope">
							<span>
								{{ formatISODate(scope.row.validStart) }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="结束时间">
						<template slot-scope="scope">
							<span>
								{{ formatISODate(scope.row.validEnd) }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="是否启用">
						<template slot-scope="scope">
							<span>
								{{ scope.row.isActive == 1 ? '启用' : '禁用' }}
							</span>
						</template>
					</el-table-column>

					<!-- <el-table-column label="是否启用">
						<template slot-scope="scope">
							<el-switch v-model="switchvalue"></el-switch>
						</template>
					</el-table-column> -->
					<el-table-column label="操作">
						<template slot-scope="scope">
							<!-- <el-button v-if="scope.row.isActive == 1" type="text" @click="submit(scope.row)" style="margin-right: 20px">禁用</el-button>
							<el-button v-else type="text" @click="submit(scope.row)" style="margin-right: 20px">启用</el-button> -->
							<el-button @click="updateinfo(scope.row)" type="text" style="margin-right: 20px">编辑</el-button>

							<el-button type="text" @click="deletePublish(scope.row.publishKey)" style="margin-right: 20px">删除</el-button>
							<!-- <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row.memberPackageId)">
								<el-button type="text" style="color: #f24b4e" slot="reference">删除</el-button>
							</el-popconfirm> -->
						</template>
					</el-table-column>
				</el-table>
				<el-pagination :hide-on-single-page="true" @current-change="handleinitialization" :current-page.sync="formInline.pageIndex" :page-size="formInline.pageSize" layout="total, prev, pager, next" :total="formInline.PageTotal"></el-pagination>
			</div>
			<!-- 发布 -->
			<div class="publish" v-else>
				<el-form label-width="100px">
					<el-form-item label="发布主题">
						<el-input type="text" v-model="upsertpublish.publishSubject" class="inputwidth"></el-input>
					</el-form-item>

					<el-form-item label="发布类型">
						<el-radio-group v-model="upsertpublish.publishType">
							<el-radio :label="0">团体</el-radio>
							<el-radio :label="1">个体</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="发布服务">
						<el-select v-model="upsertpublish.trainType" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="发布训练">
						<div class="btnpopups">
							<el-input type="textarea" v-model="showitem" class="inputwidth"></el-input>
							<el-button type="primary" @click="showdialog()">选择训练项目</el-button>
						</div>
					</el-form-item>

					<el-form-item label="发布部门对象">
						<div class="btnpopups">
							<el-input type="textarea" v-model="shoDeptwitem" class="inputwidth"></el-input>
							<el-button type="primary" @click="showdialogDept()">发布部门对象</el-button>
						</div>
					</el-form-item>

					<el-form-item label="是否启用">
						<el-switch v-model="upsertpublish.isActive"></el-switch>
					</el-form-item>
					<el-form-item label="起止时间">
						<el-date-picker class="inputwidth" v-model="timeQuantum" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
					</el-form-item>
					<!-- <el-form-item label="排序">
						<el-input type="text" class="inputwidth"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" class="inputwidth"></el-input>
					</el-form-item> -->
				</el-form>
				<div style="">
					<el-button type="primary" @click="submit('insert')">保存</el-button>
					<el-button @click="activeName = 'first'">取消</el-button>
				</div>
			</div>
		</main>

		<el-dialog title="发布训练" width="30%" :visible.sync="dialogFormVisible">
			<el-form>
				<div class="dialogtree">
					<el-tree :data="treedata" show-checkbox default-expand-all node-key="trainKey" ref="tree" highlight-current :props="defaulttrainProps"></el-tree>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="getCheckedNodes">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="选择部门" width="30%" :visible.sync="dialogDeptVisible">
			<el-form>
				<div class="dialogtree">
					<el-tree ref="depttree" @check-change="check" :check-strictly="isCheck" :data="DeptmentByNodedata" show-checkbox highlight-current :props="defaultProps" :filter-node-method="filterNode" node-key="DeptID"></el-tree>
				</div>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogDeptVisible = false">取 消</el-button>
				<el-button type="primary" @click="getCheckedDeptNodes">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				loading: false,
				upsertpublish: {
					publishKey: '',
					publishSubject: '',
					publishType: 0,
					trainType: 0,
					coverURL: '',
					validStart: '',
					validEnd: '',
					isActive: 0,
					deptIDs: '',
					trainList: [],
					userList: [],
				},
				formInline: {
					keyword: '',
					publishType: 0,
					trainType: 0,
					state: 0,
					userID: '',
					pageSize: 10,
					pageIndex: 1,
					PageTotal: 0,
				},
				timeQuantum: [new Date(), new Date()],
				activeName: 'first',
				dialogFormVisible: false,
				dialogDeptVisible: false,
				switchvalue: false,
				radio: '',
				DeptmentByNodedata: [],
				isCheck: false,
				zonglist: '',
				defaultProps: { children: 'children', label: 'label' },
				defaulttrainProps: { children: 'children', label: 'trainName', id: 'trainKey' },
				pickerOptions: {
					disabledDate(time) {
						const now = new Date();
						const nowTime = now.getTime();
						const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
						const todayTime = today.getTime();
						// 禁用小于今天（不包括今天）的日期
						return time.getTime() < todayTime;
					},
				},
				showitem: '',
				shoDeptwitem: '',
				tableData: [],
				props: {
					label: 'name',
					children: 'zones',
				},

				count: 1,
				options: [
					{
						value: 0,
						label: '发布训练',
					},
					{
						value: 1,
						label: '发布套餐',
					},
				],
				treedata: [],
			};
		},
		created() {
			this.queryList();
			this.querydep();
		},
		mounted() {},
		methods: {
			handleCheckChange(data, checked, indeterminate) {
				// console.log(data, checked, indeterminate);
			},
			handleNodeClick(data) {
				// console.log(data);
			},
			formatISODate(isoString) {
				console.log(isoString);
				const date = new Date(isoString);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			btnadd() {
				this.activeName = 'detail';
				this.upsertpublish = {
					publishKey: '',
					publishSubject: '',
					publishType: 0,
					trainType: 0,
					coverURL: '',
					validStart: '',
					validEnd: '',
					isActive: 0,
					deptIDs: '',
					trainList: [],
					userList: [],
				};
				this.showitem = '';
				this.shoDeptwitem = '';
			},
			loadNode(node, resolve) {
				if (node.level === 0) {
					return resolve([{ name: 'region1' }, { name: 'region2' }]);
				}
				if (node.level > 3) return resolve([]);

				var hasChild;
				if (node.data.name === 'region1') {
					hasChild = true;
				} else if (node.data.name === 'region2') {
					hasChild = false;
				} else {
					hasChild = Math.random() > 0.5;
				}

				setTimeout(() => {
					var data;
					if (hasChild) {
						data = [
							{
								name: 'zone' + this.count++,
							},
							{
								name: 'zone' + this.count++,
							},
						];
					} else {
						data = [];
					}
					resolve(data);
				}, 500);
			},
			updateinfo(row) {
				this.activeName = 'detail';
				console.log(this.timeQuantum);
				this.upsertpublish = row;
				this.timeQuantum[0] = this.upsertpublish.validStart;
				this.timeQuantum[1] = this.upsertpublish.validEnd;
				this.upsertpublish.isActive = this.upsertpublish.isActive == 0 ? false : true;
				this.$Http_Post('/management/game/getpublishinfo', {
					publishKey: row.publishKey,
				}).then((res) => {
					console.log(res);
					if (res.Code == 0) {
						this.upsertpublish.trainList = res.Data.publishTrainList.map((item) => item.trainKey);
						let deptIDs = res.Data.publishObjectList.map((item) => item.deptID);
						this.upsertpublish.deptIDs = deptIDs.slice(0, -1).join(',') + ',' + deptIDs[deptIDs.length - 1];

						let deptIDName = res.Data.publishObjectList.map((item) => item.deptName);
						this.shoDeptwitem = deptIDName.join('\n');

						let TrainListname = res.Data.publishTrainList.map((item) => item.trainName);
						this.showitem = TrainListname.join('\n');
					}
				});
			},

			// 获取全部单位
			querydep() {
				this.$Http_Post('DepartMent/GetDeptmentByNodeAPP').then((res) => {
					if (res.Code == 0) {
						this.DeptmentByNodedata = res.Data;
					}
				});
				let parentKeylist = [];
				this.$Http_Post('/app/game/gettrainlist', { trainKeys: [], keyword: '', level: 0, publishFlag: 0, state: 0, userID: '', pageSize: 0, pageIndex: 0 }).then((res) => {
					if (res.Code == 0) {
						res.Data.forEach((element) => {
							parentKeylist.push(element.trainKey);
							this.treedata.push({
								trainKey: element.trainKey,
								trainName: element.trainName,
								children: [],
							});
						});
						this.$Http_Post('/app/game/gettrainlist', { trainKeys: parentKeylist, keyword: '', level: 0, publishFlag: 0, state: 0, userID: '', pageSize: 99999, pageIndex: 0 }).then((res) => {
							if (res.Code == 0) {
								this.treedata.forEach((element) => {
									let filteredObjects = res.Data.filter((obj) => obj.ptrainKey === element.trainKey);
									let childrens = [];
									filteredObjects.forEach((childrenList) => {
										childrens.push({
											trainKey: childrenList.trainKey,
											trainName: childrenList.trainName,
											children: [],
										});
									});
									element.children = childrens;
								});
							}
						});
					}
				});
			},
			queryList() {
				this.loading = true;
				this.$Http_Post('/management/game/getpublishlist', this.formInline).then((res) => {
					console.log(res);
					if (res.Code == 0) {
						this.tableData = res.Data;
						this.loading = false;
					}
				});
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},

			deletePublish(row) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.$Http_Post('/management/game/deletepublish', {
							publishKey: row,
						}).then((res) => {
							if (res.Code == 0) {
								this.$message({
									type: 'success',
									message: '删除成功!',
								});
								this.queryList();
							} else {
								this.$message({
									type: 'success',
									message: res.Message,
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除',
						});
					});
			},
			submit(row) {
				let loadings = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
				});

				if (row != 'insert') {
					this.upsertpublish = row;
					if (this.upsertpublish.isActive == 0) {
						this.upsertpublish.isActive = 1;
					} else {
						this.upsertpublish.isActive = 0;
					}
					this.$Http_Post('/management/game/getpublishinfo', {
						publishKey: row.publishKey,
					}).then((res) => {
						if (res.Code == 0) {
							this.upsertpublish.trainList = res.Data.publishTrainList.map((item) => item.trainKey);
							let deptIDs = res.Data.publishObjectList.map((item) => item.deptID);
							this.upsertpublish.deptIDs = deptIDs.slice(0, -1).join(',') + ',' + deptIDs[deptIDs.length - 1];
							console.log(this.upsertpublish);
							this.upsertpublish.validStart = this.formatISODate(this.upsertpublish.validStart);
							this.upsertpublish.validEnd = this.formatISODate(this.upsertpublish.validEnd);

							this.$Http_Post('/management/game/upsertpublish', this.upsertpublish).then((res) => {
								if (res.Code == 0) {
									this.$message({
										message: res.Message,
										type: 'success',
									});
									this.queryList();
								}
							});
						}
					});
				} else {
					this.loading = true;
					this.upsertpublish.validStart = this.timeQuantum[0];
					this.upsertpublish.validEnd = this.timeQuantum[1];
					this.upsertpublish.isActive = this.upsertpublish.isActive ? 1 : 0;
					this.$Http_Post('/management/game/upsertpublish', this.upsertpublish).then((res) => {
						if (res.Code == 0) {
							loadings.close();
							this.$message({
								message: res.Message,
								type: 'success',
							});
							this.activeName = 'first';
						}
					});
				}
			},
			getSimpleCheckedNodes(store) {
				//定义数组
				const checkedNodes = []; //判断是否为全选，若为全选状态返回被全选的节点，不为全选状态正常返回被选中的节点
				const traverse = function (node) {
					const childNodes = node.root ? node.root.childNodes : node.childNodes;
					childNodes.forEach((child) => {
						if (child.checked) {
							checkedNodes.push(child.data);
						}
						if (child.indeterminate) {
							traverse(child);
						}
					});
				};
				traverse(store);
				return checkedNodes;
			},
			check(a, check, b) {
				//部门点击事件
				this.zonglist = this.getSimpleCheckedNodes(this.$refs.dialog.store);
			},
			// 分页
			handleinitialization() {
				this.queryList();
			},
			showdialog() {
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs.tree.setCheckedKeys(this.upsertpublish.trainList);
				});
			},
			showdialogDept() {
				this.dialogDeptVisible = true;
				let deptIDs = this.upsertpublish.deptIDs.split(',');
				this.$nextTick(() => {
					this.$refs.depttree.setCheckedKeys(deptIDs);
				});
			},

			getCheckedDeptNodes() {
				this.dialogDeptVisible = false;
				//获取选择的训练
				this.shoDeptwitem = '';
				this.$refs.depttree.getCheckedNodes().forEach((element) => {
					if (element.children.length == 0) {
						this.shoDeptwitem += element.label + '\n';
						this.upsertpublish.deptIDs += element.value + ',';
					}
				});
				this.upsertpublish.deptIDs = this.upsertpublish.deptIDs.substring(0, this.upsertpublish.deptIDs.length - 1);
			},

			getCheckedNodes() {
				this.dialogFormVisible = false;
				this.showitem = '';
				this.$refs.tree.getCheckedNodes().forEach((element) => {
					if (element.children.length == 0) {
						this.upsertpublish.trainList.push(element.trainKey);
						this.showitem += element.trainName + '\n';
					}
				});
			},
		},
	};
</script>
<style scoped>
	.PublishPackage header {
		background: #fff;
		border-radius: 8px;
		padding: 10px 5px;
	}
	.PublishPackage header .header {
		display: flex;
		font-size: 14px;
		text-align: center;
	}
	.PublishPackage header .header .item {
		margin: 10px;
		cursor: pointer;
	}
	.PublishPackage header .header .item i {
		font-size: 18px;
	}
	.PublishPackage main {
		background: #fff;
		margin: 15px 0;
		padding: 15px;
		border-radius: 8px;
	}
	.PublishPackage main .tabs {
		border-bottom: 1px solid #eeeeee;
		display: flex;
	}
	.PublishPackage main .tabs .item {
		font-size: 16px;
		border-bottom: 1px solid #eeeeee;
		padding: 12px 0;
		width: 96px;
		text-align: center;
		cursor: pointer;
	}
	.PublishPackage main .tabs .item.on {
		color: #1677ff;
		border-bottom: 1px solid #1677ff;
	}
	.PublishPackage main .gamelist {
		margin: 15px 0;
	}
	.PublishPackage main .publish {
		margin: 15px 0;
	}
	.PublishPackage .inputwidth {
		width: 300px;
	}
	.PublishPackage .btnpopups {
		display: flex;
		align-items: center;
	}
	.PublishPackage .btnpopups button {
		margin-left: 15px;
	}

	.PublishPackage .dialogtree {
		max-height: 600px;
		overflow: auto;
	}

	.PublishPackage .btnlist {
		padding-bottom: 10px;
		border-bottom: 1px solid #eeeeee;
	}
</style>
